import { React, useState,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { UserForm } from '../UserForm/UserForm';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function EditUser() {
  const { t } = useTranslation();
  const { personId } = useParams();
  const [userFormData, setUserFormData] = useState({
    username: '',
    name: '',
    surnames: '',
    password: '',
    phone: '',
    controlCentreId: 0,
    role: '',
    isActive: true
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUserData() {
      try {
        const response = await api.getUser(personId);
        if (response.status === 200) {
          const updatedUserData = {
            ...response.data,
            password: ''
            };

            setUserFormData(updatedUserData);
        } else {
            setError(t('usErrorFetchUserData'));
        }
      } catch (error) {
          setError(t('usErrorFetchUserData'));
      }
    }
    fetchUserData();
  }, [personId]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserFormData({
        ...userFormData,
      [name]: value
    });
  };

  const handleSubmit = async () => {
    const response = await api.updateUser(personId, userFormData);
    if (response.status === 200) {

      navigate('/userManagement');      
    } else {
        setError(t('usError'));
    }
  };
  
    return (
        <Container>
            <h2 className="mt-4">{t('usEdit')}</h2>
        <UserForm
          userFormData={userFormData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          error={error}
          setError={setError}
          isEditing={true}
        />
        </Container>
    );
}